import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {ApiProvider} from '../api/api';
import {Platform} from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {LoggerProvider, LogLevel} from '../logger/logger';


@Injectable()
export class AudioProvider {

  private log_level: LogLevel = LogLevel.Error;
  private log_label_main: string = 'AudioProvider';

  public audio: any = new Audio();
  public channel_id: number;
  public playing:boolean = false;

  public selectedStream: any;
  public autoPlay: boolean = true;

  public timestamp: any;
  public current: any;
  public next: Array<any> = [];
  private nextJSON: any;

  public streamInfo: Subject<any> = new Subject<any>();

  private fetchPlaylist: number = 1000;
  private timeout: any;
  private playlistLoop: boolean = false;

  // 2018-11-05
  public lastVolume: number = null;

  constructor(
    private apiProvider: ApiProvider,
    public platform: Platform,
    public storage: Storage,
    private logger: LoggerProvider
  ) {
    let me = this;
    let log_label: string = me.log_label_main + '::constructor';
    me.logger.setLogLevel(me, LogLevel.Warning);

    me.logger.warn(me, log_label);
  }

  appReady(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::appReady';

    me.logger.warn(me, log_label);

    // promises
    let promises: Array<any> = [];

    return new Promise((resolve, reject) => {
      // 2018-11-07
      promises.push(me.loadVolume());

      promises.push(me.initVars());

      Promise.all(promises).then(() => {
        me.logger.warn(me, log_label + ':resolve');

        me.logger.setLogLevel(me, me.log_level);

        resolve();

      }, error => {
        me.logger.error(me, log_label + ':error', {error: error});

        me.logger.setLogLevel(me, me.log_level);

        reject(error);
      });
    });
  }

  private initVars(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::initVars';

    me.logger.warn(me, log_label);

    return new Promise(resolve => {
      // autoplay
      if (me.platform.is('mobile')) {
        me.autoPlay = false;
      }

      me.logger.info(me, log_label + ':resolve');
      resolve();
    });
  }

  stopPlaying(): void {
    let me = this;
    let log_label = me.log_label_main + '::stopPlaying';

    me.logger.warn(me, log_label);

    me.audio.pause();
    me.playing = false;
  }

  setSelectedStream(selectedStream: any, force: boolean = false): void {
    let me = this;
    let log_label = me.log_label_main + '::setSelectedStream';

    me.logger.warn(me, log_label, {selectedStream: selectedStream, force: force});

    me.selectedStream = selectedStream;

    if (
      me.channel_id != me.selectedStream.channel_id
      ||
      force
    ) {
      me.stopPlaylistInfo();

      me.logger.info(me, log_label + ':check audio support');
      if (me.selectedStream.url.m4a && me.audio.canPlayType('audio/mp4')) {
        me.logger.info(me, log_label + ':check audio support:aac');
        me.audio.src = me.selectedStream.url.m4a;

      } else if (me.selectedStream.url.ogg && me.audio.canPlayType('audio/ogg')) {
        me.logger.info(me, log_label + ':check audio support:ogg');
        me.audio.src = me.selectedStream.url.ogg;

      } else if (me.selectedStream.url.mp3 && me.audio.canPlayType('audio/mp3')) {
        me.logger.info(me, log_label + ':check audio support:mp3');
        me.audio.src = me.selectedStream.url.mp3;
      }

      if (me.audio.src) {
        me.channel_id = me.selectedStream.channel_id;
        me.audio.onplay = function () {
          me.logger.warn(me, log_label + ':onplay');
          me.playing = true;
          me.startPlaylistInfo();
        };
        me.audio.onpause = function () {
          me.logger.warn(me, log_label + ':onpause');
          me.playing = false;
          me.stopPlaylistInfo();
        };
        /*me.audio.onabort = function () {
          console.log('audio::onabort');
          me.stopPlaylistInfo();
        };*/

        if (me.autoPlay) {
          me.audio.play();
          me.playing = true;
          me.logger.warn(me, log_label + ':autoplay:audio', me.audio, me.audio.volume);

        } else {
          me.logger.warn(me, log_label + ':autoplay:audio', 'off');
        }
      }
    } else {
      me.logger.warn(me, log_label + ':audio::nothing todo - stream is running');
    }
  }

  private createTimeout(timeout: number): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::createTimeout';

    me.logger.warn(me, log_label, timeout);

    return new Promise((resolve, reject) => {
      me.timeout = setTimeout(() => resolve(null), timeout)
    })
  }

  startPlaylistInfo(): void {
    let me = this;
    let log_label = me.log_label_main + '::startPlaylistInfo';

    me.logger.warn(me, log_label, me.channel_id);

    if (me.autoPlay) {
      me.playlistLoop = true;
    }

    me.callGetCurrentPlaylist();
  }

  stopPlaylistInfo(): void {
    let me = this;
    let log_label = me.log_label_main + '::stopPlaylistInfo';

    me.logger.warn(me, log_label, {channel_id: me.channel_id, playlistLoop: me.playlistLoop, timeout: me.timeout});

    me.playlistLoop = false;

    if (me.timeout) {
      clearTimeout(me.timeout);
    }
  }

  callGetCurrentPlaylist(): void {
    let me = this;
    let log_label = me.log_label_main + '::callGetCurrentPlaylist';

    me.logger.warn(me, log_label, {playlistLoop: me.playlistLoop});

    me.apiProvider.callGetCurrentPlaylist(me.selectedStream.channel_id).then(
      data => {
        me.logger.warn(me, log_label + ':data', data);

        if (data.success) {
          me.timestamp = data.timestamp;
          me.current = data.current;

          if (me.nextJSON != JSON.stringify(data.next)) {
            me.logger.warn(me, log_label + ':data:next', {playlistLoop: me.playlistLoop});

            me.next = data.next.slice(0, 9);
            me.nextJSON = JSON.stringify(data.next);
          }

          let played: string = String(me.current.played);
          let value: number = parseFloat(played.replace(':', '.'));/**/

          me.streamInfo.next({
            value: value,
            goal: me.current.duration
          });

          if (me.playlistLoop) {
            me.createTimeout(me.fetchPlaylist).then(() => {
              me.callGetCurrentPlaylist();
            });
          }
        }
      },
      error => {
        me.logger.warn(me, log_label + ':error', error);
      }
    );
  }

  private loadVolume(): Promise<any> {
    let me = this;
    let log_label: string = me.log_label_main + '::loadVolume';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {

      me.storage.get('last_volume').then((volume) => {
        me.logger.warn(me, log_label + ':get:last_volume', volume);
        me.lastVolume = volume;

        me.logger.info(me, log_label + ':resolve');
        resolve();

      }, error => {
        me.logger.warn(me, log_label + ':get:last_volume:error', error);
        reject(error);
      });
    });
  }

  changeVolume(volume: number): void {
    let me = this;
    let log_label: string = me.log_label_main + '::changeVolume';

    me.logger.warn(me, log_label + ':volume', volume);

    me.lastVolume = volume;
    me.audio.volume = volume / 100;

    me.storage.set('last_volume', volume).then(() => {
      me.logger.warn(me, log_label + ':set:last_volume', volume);

    }, error => {
      me.logger.warn(me, log_label + ':set:last_volume:error', error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/audio/audio.ts